import { Flex, FlexSpace } from 'components/base'
import { Image } from 'components/icons'
import styled from 'styled-components'

export const InputContent = styled(FlexSpace)`
  height: 40px;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
`
export const AssetWrapper = styled(Flex)`
  gap: 5px;
`

export const AssetIcon = styled(Image)`
  background-size: cover;
  height: 24px;
  width: 24px;
  border-radius: 50%;
`

export const LoaderWrapper = styled(Flex)``
